'use client'

import { useEffect } from 'react'

import { track } from '@/features/analytics'
import { LifiBridgeWidget } from '@/containers/LifiBridge'
// import { useAccount } from '@/domain/hooks/useAccount'
// import { Button } from '@/ui/atoms/button/Button'
// import { usePrivy } from '@privy-io/react-auth'
// import { Loader2 } from 'lucide-react'

export function CrossChainPage() {
  useEffect(() => {
    track('bridge_form_viewed', { source: 'bridge_page' })
  }, [])

  // const account = useAccount()
  // const { connectWallet } = usePrivy()

  // const themeConfig = {
  //   theme: {
  //     recipes: {
  //       button: {
  //         base: {
  //           color: '#0B0B0D',
  //           fontWeight: '600',
  //           borderRadius: '8px',
  //           transition: 'all 0.2s',
  //           _hover: {
  //             color: '#0B0B0D',
  //           },
  //           _active: {
  //             color: '#0B0B0D',
  //           },
  //           _focus: {
  //             color: '#0B0B0D',
  //           },
  //         },
  //         variants: {
  //           variant: {
  //             solid: {
  //               color: '#0B0B0D',
  //               bg: 'hsl(166, 94%, 81%)',
  //               _hover: {
  //                 color: '#0B0B0D',
  //                 bg: 'hsl(166, 94%, 71%)',
  //               },
  //               _active: {
  //                 color: '#0B0B0D',
  //                 bg: 'hsl(166, 94%, 71%)',
  //               },
  //             },
  //             outline: {
  //               color: '#0B0B0D',
  //               bg: 'transparent',
  //               border: '1px solid rgba(255, 255, 255, 0.04)',
  //               _hover: {
  //                 color: '#0B0B0D',
  //                 bg: 'hsl(0, 0%, 15.1%)',
  //               },
  //             },
  //             ghost: {
  //               color: '#0B0B0D',
  //               bg: 'transparent',
  //               _hover: {
  //                 color: '#0B0B0D',
  //                 bg: 'hsl(0, 0%, 15.1%)',
  //               },
  //             },
  //           },
  //         },
  //       },
  //     },
  //     tokens: {
  //       colors: {
  //         gray: {
  //           50: { value: 'hsl(0, 0%, 100%)' }, // --foreground
  //           500: { value: '#71717A' }, // --muted
  //         },
  //         primary: {
  //           50: { value: 'hsl(166, 94%, 95%)' },
  //           100: { value: 'hsl(166, 94%, 90%)' },
  //           200: { value: 'hsl(166, 94%, 85%)' },
  //           300: { value: 'hsl(166, 94%, 81%)' }, // --primary
  //           400: { value: 'hsl(166, 94%, 76%)' },
  //           500: { value: 'hsl(166, 94%, 71%)' }, // --primary-hover
  //           600: { value: 'hsl(166, 94%, 66%)' },
  //           700: { value: 'hsl(166, 94%, 61%)' },
  //           800: { value: 'hsl(166, 94%, 56%)' },
  //           900: { value: 'hsl(166, 94%, 51%)' },
  //         },
  //         blue: {
  //           600: { value: 'rgb(161, 252, 231)' },
  //         },
  //         green: {
  //           500: { value: 'hsl(51, 190%, 39%)' }, // --basics-green
  //         },
  //         red: {
  //           500: { value: 'hsl(220, 38%, 38%)' }, // --basics-red
  //         },
  //         // Additional project colors
  //         accent: { value: 'hsl(0, 0%, 5%)' }, // --accent
  //         ring: { value: 'hsl(166, 94%, 81%)' }, // --ring
  //       },
  //       radii: {
  //         sm: { value: '8px' },
  //         md: { value: '12px' },
  //         lg: { value: '16px' }, // --radius is 1rem = 16px
  //       },
  //       shadows: {
  //         base: { value: 'rgba(9, 24, 44, 0.07) 0px 4px 8px' }, // --tooltip-shadow
  //       },
  //     },
  //     semanticTokens: {
  //       colors: {
  //         bg: {
  //           value: { base: 'rgba(19, 19, 22, 1)', _dark: 'rgba(19, 19, 22, 1)' }, // --panel
  //         },
  //         'bg.canvas': {
  //           value: { base: 'hsl(0, 0%, 0%)', _dark: 'hsl(0, 0%, 0%)' }, // --background
  //         },
  //         'bg.surface': {
  //           value: { base: 'rgba(19, 19, 22, 1)', _dark: 'rgba(19, 19, 22, 1)' }, // --panel
  //         },
  //         'bg.subtle': {
  //           value: { base: 'hsl(0, 0%, 5%)', _dark: 'hsl(0, 0%, 5%)' }, // --card
  //         },
  //         'bg.muted': {
  //           value: { base: 'hsl(0, 0%, 15.1%)', _dark: 'hsl(0, 0%, 15.1%)' }, // --muted
  //         },
  //         'bg.panel': {
  //           value: { base: 'hsl(0, 0%, 15.1%)', _dark: 'hsl(0, 0%, 15.1%)' }, // --panel
  //         },
  //         fg: {
  //           value: { base: 'hsl(0, 0%, 100%)', _dark: 'hsl(0, 0%, 100%)' }, // --foreground
  //         },
  //         'fg.muted': {
  //           value: { base: 'rgba(255, 255, 255, 0.6)', _dark: 'rgba(255, 255, 255, 0.6)' }, // muted text
  //         },
  //         'fg.subtle': {
  //           value: { base: 'hsl(0, 0%, 52%)', _dark: 'hsl(0, 0%, 52%)' }, // --link-inactive
  //         },
  //         'fg.disabled': {
  //           value: { base: 'hsl(0, 0%, 15.1%)', _dark: 'hsl(0, 0%, 15.1%)' }, // disabled text
  //         },
  //         border: {
  //           value: { base: 'rgba(255, 255, 255, 0.04)', _dark: 'rgba(255, 255, 255, 0.04)' }, // --border
  //         },
  //         'border.subtle': {
  //           value: { base: 'rgba(255, 255, 255, 0.04)', _dark: 'rgba(255, 255, 255, 0.04)' }, // subtle borders
  //         },
  //         'border.muted': {
  //           value: { base: 'hsl(0, 0%, 15.1%)', _dark: 'hsl(0, 0%, 15.1%)' }, // muted borders
  //         },
  //       },
  //     },
  //   },
  //   config: {
  //     initialColorMode: 'dark',
  //   },
  // }

  return (
    <div className="flex flex-col gap-4">
      <div className="relative min-h-[400px] w-full">
        {/* Loading spinner - will be hidden automatically by SwapWidget when loaded */}
        {/* <div className="absolute inset-0 z-0 flex items-center justify-center bg-transparent">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div> */}

        <div className="relative z-10">
          <LifiBridgeWidget />
        </div>
      </div>
      {/* {!account && (
        <Button className="w-full rounded-lg" onClick={connectWallet}>
          Connect wallet
        </Button>
      )} */}
    </div>
  )
}
